import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql } = useAppContext();

  const ConfirmationFragment = gql`
fragment ConfirmationFragment on Confirmation {
  id
  confirmed
  confirmedThroughStore
  emailSentAt
  fourDaysConfirmation
  fourDaysConfirmedAt
  reminderNotConfirmed
  canceled
  canceledAt
  smsSent
}
`;

  const ConfirmationReducedFragment = gql`
fragment ConfirmationReducedFragment on Confirmation {
  id
  confirmed
  fourDaysConfirmation
  canceled
}
`;

  return {
    ConfirmationFragment,
    ConfirmationReducedFragment,
  };
};
